var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C4566",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 1a8.6 8.6 0 0 1 8.6 8.6A8.6 8.6 0 1 1 9.6 1Zm0 1.119a7.48 7.48 0 1 0 0 14.962 7.48 7.48 0 0 0 0-14.962Z",
    stroke: "#1C4566",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.201 3.684a.743.743 0 0 1 .61.328.662.662 0 0 1 .09.528.68.68 0 0 1-.236.366l-.094.064-.348.204.145.018c2.43.353 4.25 2.333 4.253 4.677l-.005.214c-.118 2.58-2.397 4.594-5.127 4.537-2.73-.058-4.914-2.166-4.91-4.747 0-.305.259-.55.576-.55.317 0 .576.244.576.549-.001 1.975 1.67 3.592 3.77 3.642 2.098.05 3.854-1.487 3.958-3.46.095-1.78-1.187-3.334-2.979-3.727l-.139-.027.207.127c.24.15.363.418.322.683l-.024.1a.728.728 0 0 1-.699.493.763.763 0 0 1-.305-.064l-.093-.048-2.17-1.347a.682.682 0 0 1-.33-.591.678.678 0 0 1 .263-.523L7.6 5.07l2.213-1.28a.797.797 0 0 1 .39-.107Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.8dbbe52e2e27b62e1bd7cf554eb923eb.svg";
export { ForwardRef as ReactComponent };